module.exports = __webpack_public_path__ + "img/desayuno.6fa4e460.svg";